import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi',
  },
  // preset,
  // rtl: true,
  // theme: { light: true, dark: false },
  theme: {
    themes: {
      // light: {
      //   primary: "#ef9a9a",
      //   secondary: "#607d8b",
      //   accent: "#4db6ac",
      //   error: "#b71c1c",
      //   info: "#bbdefb",
      //   success: "#a5d6a7",
      //   warning: "#ffc107"
      // },
      light: {
        // blue: "#007bff",
        // indigo: "#6610f2",
        // purple: "#6f42c1",
        // "deep-purple": "#564fc1",
        // pink: "#e83e8c",
        // red: "#dc3545",
        // orange: "#fd7e14",
        // yellow: "#ffc107",
        // green: "#28a745",
        // teal: "#20c997",
        // cyan: "#17a2b8",
        // white: "#ffffff",
        // gray: "#6c757d",
        // "gray-dark": "#343a40",
        // primary: "#5867dd",
        // secondary: "#607d8b", //"#e1e1ef",
        // success: "#1dc9b7",
        // info: "#22b9ff",
        // warning: "#ffb822",
        // danger: "#fd27eb",
        // light: "#f8f9fa",
        // dark: "#343a40",
        applicationbar: colors.white,
				avatarchipcolor: colors.orange.lighten3,
				avatarchiplabelcolor: colors.orange.lighten5,
				avatarlabelcolor: colors.orange.darken4,
				avatarbgcolor: colors.orange.accent3,
				headcolor: colors.orange.accent1,
				headlabelcolor: colors.orange.darken4,
				headrowcolor1: colors.orange.darken4,
				headrowcolor2: colors.orange.darken3,
				headrowcolor3: colors.orange.darken2
      },
    },
  }
}
export default new Vuetify(opts)